export default {
    methods: {
        criarFiltroBuscaFontesFinanciamento ({
            situacao = null}) {
            return {
                filtro: {
                    situacao: situacao,
                }
            }
        }
    },
}
